import { render } from "./ItemsChoice.vue?vue&type=template&id=9c373bca&ts=true"
import script from "./ItemsChoice.vue?vue&type=script&lang=ts"
export * from "./ItemsChoice.vue?vue&type=script&lang=ts"

import "./ItemsChoice.vue?vue&type=style&index=0&id=9c373bca&lang=scss"

import exportComponent from "/builds/rma/ufg-rma/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__